export enum REACTION_TYPE {
  /**
   * UPVOTE corresponds to a reaction to a comment from a user.
   */
  UPVOTE = "UPVOTE",

  /**
   * DOWNVOTE corresponds to a reaction to a comment from a user.
   */
  DOWNVOTE = "DOWNVOTE",
}
